import { createSvgIcon } from '@mui/material';

export const ACCG = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='76'
    height='76'
    viewBox='0 0 76 76'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.7176 19.3896C23.7137 20.5384 23.7099 21.6872 23.7099 22.836V23.5064H24.4321C25.6012 23.5064 26.7702 23.5119 27.9391 23.5173C30.614 23.5298 33.2886 23.5422 35.9621 23.4894C39.3936 23.4215 42.5866 26.0048 42.5753 30.1192C42.5568 36.6899 42.5606 43.2611 42.5643 49.8325C42.5658 52.5285 42.5674 55.2245 42.5674 57.9206V58.7688H43.232C45.0552 58.7688 46.8782 58.769 48.7013 58.7692C53.265 58.7697 57.8284 58.7701 62.3923 58.7677C64.8835 58.7666 66.4568 57.2082 66.4568 54.7155C66.4625 40.1455 66.4625 25.5744 66.4602 11.0044C66.4602 8.73597 64.7535 7.1006 62.381 7.0972C58.0103 7.09154 53.6395 7.09154 49.2688 7.1074C48.8302 7.10966 48.5928 7.01 48.3645 6.5819C47.6818 5.30101 46.5584 4.62602 45.1048 4.61583C43.6016 4.60564 42.4656 5.30781 41.7536 6.62607C41.5535 6.99641 41.3478 7.10966 40.9409 7.10853C38.8238 7.1003 36.7067 7.10031 34.5896 7.10032C32.336 7.10033 30.0823 7.10033 27.8286 7.09041C25.264 7.07908 23.6579 8.93303 23.6929 11.172C23.7359 13.9105 23.7268 16.6501 23.7176 19.3896ZM46.3346 8.4098C46.3165 9.08026 45.7084 9.66464 45.0472 9.64766C44.3566 9.63067 43.8299 9.06894 43.8367 8.35771C43.8423 7.67139 44.4391 7.08474 45.1003 7.11306C45.7615 7.14024 46.3526 7.762 46.3346 8.4098ZM49.0345 9.66606C48.7769 9.66133 48.6876 9.65969 48.3645 10.1371C46.8262 12.4848 43.0556 12.6366 41.749 10.1371C41.5478 9.75314 41.3387 9.65461 40.9375 9.65914C39.5138 9.67411 38.0896 9.67198 36.628 9.66979C36.0995 9.669 35.5661 9.6682 35.0261 9.6682V10.9094C35.0261 11.1593 35.0252 11.4091 35.0242 11.6589C35.0218 12.2584 35.0195 12.8577 35.0307 13.4565C35.0567 14.8631 36.1112 15.9164 37.515 15.9186C42.5255 15.9254 47.5349 15.9254 52.5454 15.9175C53.9955 15.9152 55.0195 15.0058 55.1213 13.5471C55.1737 12.7928 55.1627 12.0342 55.1518 11.2757C55.1469 10.9387 55.142 10.6016 55.1427 10.265V9.66367C54.2842 9.66367 53.2042 9.66338 52.1373 9.66309C51.096 9.66281 50.0671 9.66254 49.2687 9.66254C49.1755 9.66865 49.0996 9.66725 49.0345 9.66606Z'
      fill='url(#paint0_linear_515_30)'
    />
    <path
      d='M62.6277 32.8979H45.1017H45.1006V30.3848H47.6064V25.4085H50.093V30.3599H52.6531V22.9316H55.1724V30.3758H57.6647V26.652H60.1671V30.4233H62.6277V32.8979Z'
      fill='#2962FF'
    />
    <path
      d='M62.6277 32.2822H45.1017H45.1006V29.7691H47.6064V24.7928H50.093V29.7442H52.6531V22.3159H55.1724V29.76H57.6647V26.0363H60.1671V29.8076H62.6277V32.2822Z'
      fill='#ffffff'
    />
    <path
      d='M42.7695 54.4619H66.4618V56.9235C66.4618 57.9431 65.6353 58.7696 64.6157 58.7696H42.7695V54.4619Z'
      fill='#2962FF'
    />
    <rect
      x='9.84668'
      y='26.1543'
      width='30.1538'
      height='36.3077'
      rx='3.69231'
      fill='url(#paint1_linear_515_30)'
    />
    <rect
      x='14.7695'
      y='31.3848'
      width='20.3077'
      height='7.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='14.7695'
      y='41.5386'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='14.7695'
      y='47.6924'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='14.7695'
      y='53.8462'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='29.8467'
      y='41.5386'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='29.8467'
      y='47.6924'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='29.8467'
      y='53.8462'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='22.4619'
      y='41.5386'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='22.4619'
      y='47.6924'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='22.4619'
      y='53.8462'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#C86904'
    />
    <rect
      x='14.7695'
      y='30.4619'
      width='20.3077'
      height='7.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='14.7695'
      y='40.6157'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='14.7695'
      y='46.7695'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='14.7695'
      y='52.9233'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='29.8467'
      y='40.6157'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='29.8467'
      y='46.7695'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='29.8467'
      y='52.9233'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='22.4619'
      y='40.6157'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <rect
      x='22.4619'
      y='52.9233'
      width='5.23077'
      height='3.69231'
      rx='1.23077'
      fill='#ffffff'
    />
    <circle cx='53.8465' cy='44.9232' r='7.38461' fill='#ffffff' />
    <path
      d='M53.8687 40.5879V45.5275C52.1838 45.5275 50.5554 45.5275 48.9383 45.5275C48.6287 46.9456 49.8051 49.015 51.3951 49.9177C53.306 51.0028 55.6666 50.7253 57.2973 49.2268C58.902 47.7509 59.3563 45.3768 58.4161 43.3765C57.5787 41.5937 55.5842 40.3523 53.8687 40.589V40.5879Z'
      fill='#C86904'
    />
    <path
      d='M53.8687 39.9721V44.9117C52.1838 44.9117 50.5554 44.9117 48.9383 44.9117C48.6287 46.3299 49.8051 48.3993 51.3951 49.302C53.306 50.3871 55.6666 50.1096 57.2973 48.6111C58.902 47.1352 59.3563 44.7611 58.4161 42.7608C57.5787 40.978 55.5842 39.7365 53.8687 39.9733V39.9721Z'
      fill='url(#paint2_linear_515_30)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.4044 55.8772C10.6771 51.3331 14.8492 48.0005 19.7997 48.0005C24.6146 48.0005 28.6932 51.1531 30.0839 55.5067H31.7968C36.4973 55.5067 40.3078 59.3173 40.3078 64.0178C40.3078 68.7183 36.4973 72.5288 31.7968 72.5288H11.8958C7.19529 72.5288 3.38477 68.7183 3.38477 64.0178C3.38477 60.1841 5.91945 56.9424 9.4044 55.8772Z'
      fill='url(#paint3_linear_515_30)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.96338 53.5296C9.0363 48.4814 13.9991 44.9233 19.7994 44.9233C25.1711 44.9233 29.8239 47.9751 32.1287 52.4343C38.375 52.6101 43.3845 57.7288 43.3845 64.0175C43.3845 70.4174 38.1964 75.6055 31.7966 75.6055H11.8956C5.49573 75.6055 0.307617 70.4174 0.307617 64.0175C0.307617 59.3782 3.03212 55.3815 6.96338 53.5296ZM9.40418 55.877C10.6769 51.3328 14.849 48.0003 19.7994 48.0003C24.6144 48.0003 28.693 51.1529 30.0837 55.5065H31.7966C36.4971 55.5065 40.3076 59.317 40.3076 64.0175C40.3076 68.7181 36.4971 72.5286 31.7966 72.5286H11.8956C7.19506 72.5286 3.38454 68.7181 3.38454 64.0175C3.38454 60.1839 5.91923 56.9422 9.40418 55.877Z'
      fill='#ffffff'
    />
    <path
      d='M5.74976 67.4297L9.10976 59.8912H10.8328L14.2036 67.4297H12.3728L9.61591 60.7743H10.3051L7.53745 67.4297H5.74976ZM7.42976 65.8143L7.89283 64.4897H11.7698L12.2436 65.8143H7.42976ZM18.4882 67.5589C17.9067 67.5589 17.3647 67.4656 16.8621 67.2789C16.3667 67.0851 15.9359 66.8123 15.5698 66.4605C15.2036 66.1087 14.9164 65.6958 14.7082 65.222C14.5072 64.7481 14.4067 64.2276 14.4067 63.6605C14.4067 63.0933 14.5072 62.5728 14.7082 62.0989C14.9164 61.6251 15.2036 61.2123 15.5698 60.8605C15.9431 60.5087 16.3775 60.2394 16.8729 60.0528C17.3682 59.8589 17.9103 59.762 18.499 59.762C19.1523 59.762 19.7411 59.8769 20.2652 60.1066C20.7964 60.3292 21.2416 60.6594 21.6005 61.0974L20.4805 62.1312C20.2221 61.8369 19.9349 61.6179 19.619 61.4743C19.3031 61.3235 18.9585 61.2481 18.5852 61.2481C18.2334 61.2481 17.9103 61.3056 17.6159 61.4205C17.3216 61.5353 17.0667 61.7005 16.8513 61.9158C16.6359 62.1312 16.4672 62.3861 16.3452 62.6805C16.2303 62.9748 16.1729 63.3015 16.1729 63.6605C16.1729 64.0194 16.2303 64.3461 16.3452 64.6405C16.4672 64.9348 16.6359 65.1897 16.8513 65.4051C17.0667 65.6205 17.3216 65.7856 17.6159 65.9005C17.9103 66.0153 18.2334 66.0728 18.5852 66.0728C18.9585 66.0728 19.3031 66.001 19.619 65.8574C19.9349 65.7066 20.2221 65.4805 20.4805 65.1789L21.6005 66.2128C21.2416 66.6507 20.7964 66.9846 20.2652 67.2143C19.7411 67.444 19.1488 67.5589 18.4882 67.5589ZM26.2286 67.5589C25.6471 67.5589 25.105 67.4656 24.6025 67.2789C24.1071 67.0851 23.6763 66.8123 23.3102 66.4605C22.944 66.1087 22.6568 65.6958 22.4486 65.222C22.2476 64.7481 22.1471 64.2276 22.1471 63.6605C22.1471 63.0933 22.2476 62.5728 22.4486 62.0989C22.6568 61.6251 22.944 61.2123 23.3102 60.8605C23.6835 60.5087 24.1179 60.2394 24.6132 60.0528C25.1086 59.8589 25.6507 59.762 26.2394 59.762C26.8927 59.762 27.4814 59.8769 28.0055 60.1066C28.5368 60.3292 28.982 60.6594 29.3409 61.0974L28.2209 62.1312C27.9625 61.8369 27.6753 61.6179 27.3594 61.4743C27.0435 61.3235 26.6989 61.2481 26.3255 61.2481C25.9738 61.2481 25.6507 61.3056 25.3563 61.4205C25.062 61.5353 24.8071 61.7005 24.5917 61.9158C24.3763 62.1312 24.2076 62.3861 24.0855 62.6805C23.9707 62.9748 23.9132 63.3015 23.9132 63.6605C23.9132 64.0194 23.9707 64.3461 24.0855 64.6405C24.2076 64.9348 24.3763 65.1897 24.5917 65.4051C24.8071 65.6205 25.062 65.7856 25.3563 65.9005C25.6507 66.0153 25.9738 66.0728 26.3255 66.0728C26.6989 66.0728 27.0435 66.001 27.3594 65.8574C27.6753 65.7066 27.9625 65.4805 28.2209 65.1789L29.3409 66.2128C28.982 66.6507 28.5368 66.9846 28.0055 67.2143C27.4814 67.444 26.8891 67.5589 26.2286 67.5589ZM34.0013 67.5589C33.4054 67.5589 32.8562 67.4656 32.3536 67.2789C31.8582 67.0851 31.4239 66.8123 31.0505 66.4605C30.6844 66.1087 30.3972 65.6958 30.189 65.222C29.988 64.7481 29.8875 64.2276 29.8875 63.6605C29.8875 63.0933 29.988 62.5728 30.189 62.0989C30.3972 61.6251 30.688 61.2123 31.0613 60.8605C31.4347 60.5087 31.8726 60.2394 32.3752 60.0528C32.8777 59.8589 33.4305 59.762 34.0336 59.762C34.7013 59.762 35.3008 59.8733 35.8321 60.0958C36.3705 60.3184 36.8229 60.6415 37.189 61.0651L36.069 62.0989C35.7962 61.8117 35.4982 61.5999 35.1752 61.4635C34.8521 61.3199 34.5003 61.2481 34.1198 61.2481C33.7536 61.2481 33.4198 61.3056 33.1182 61.4205C32.8167 61.5353 32.5547 61.7005 32.3321 61.9158C32.1167 62.1312 31.948 62.3861 31.8259 62.6805C31.7111 62.9748 31.6536 63.3015 31.6536 63.6605C31.6536 64.0123 31.7111 64.3353 31.8259 64.6297C31.948 64.924 32.1167 65.1825 32.3321 65.4051C32.5547 65.6205 32.8131 65.7856 33.1075 65.9005C33.409 66.0153 33.7393 66.0728 34.0982 66.0728C34.4429 66.0728 34.7767 66.0189 35.0998 65.9112C35.43 65.7964 35.7495 65.6061 36.0582 65.3405L37.049 66.6005C36.6398 66.9092 36.1623 67.1461 35.6167 67.3112C35.0782 67.4764 34.5398 67.5589 34.0013 67.5589ZM35.4552 66.3743V63.542H37.049V66.6005L35.4552 66.3743Z'
      fill='#252C7E'
    />
    <path
      d='M5.74976 66.9238L9.10976 59.3854H10.8328L14.2036 66.9238H12.3728L9.61591 60.2684H10.3051L7.53745 66.9238H5.74976ZM7.42976 65.3084L7.89283 63.9838H11.7698L12.2436 65.3084H7.42976ZM18.4882 67.0531C17.9067 67.0531 17.3647 66.9597 16.8621 66.7731C16.3667 66.5792 15.9359 66.3064 15.5698 65.9546C15.2036 65.6028 14.9164 65.19 14.7082 64.7161C14.5072 64.2423 14.4067 63.7218 14.4067 63.1546C14.4067 62.5874 14.5072 62.0669 14.7082 61.5931C14.9164 61.1192 15.2036 60.7064 15.5698 60.3546C15.9431 60.0028 16.3775 59.7336 16.8729 59.5469C17.3682 59.3531 17.9103 59.2561 18.499 59.2561C19.1523 59.2561 19.7411 59.371 20.2652 59.6008C20.7964 59.8233 21.2416 60.1536 21.6005 60.5915L20.4805 61.6254C20.2221 61.331 19.9349 61.112 19.619 60.9684C19.3031 60.8177 18.9585 60.7423 18.5852 60.7423C18.2334 60.7423 17.9103 60.7997 17.6159 60.9146C17.3216 61.0295 17.0667 61.1946 16.8513 61.41C16.6359 61.6254 16.4672 61.8802 16.3452 62.1746C16.2303 62.469 16.1729 62.7956 16.1729 63.1546C16.1729 63.5136 16.2303 63.8402 16.3452 64.1346C16.4672 64.429 16.6359 64.6838 16.8513 64.8992C17.0667 65.1146 17.3216 65.2797 17.6159 65.3946C17.9103 65.5095 18.2334 65.5669 18.5852 65.5669C18.9585 65.5669 19.3031 65.4951 19.619 65.3515C19.9349 65.2008 20.2221 64.9746 20.4805 64.6731L21.6005 65.7069C21.2416 66.1449 20.7964 66.4787 20.2652 66.7084C19.7411 66.9382 19.1488 67.0531 18.4882 67.0531ZM26.2286 67.0531C25.6471 67.0531 25.105 66.9597 24.6025 66.7731C24.1071 66.5792 23.6763 66.3064 23.3102 65.9546C22.944 65.6028 22.6568 65.19 22.4486 64.7161C22.2476 64.2423 22.1471 63.7218 22.1471 63.1546C22.1471 62.5874 22.2476 62.0669 22.4486 61.5931C22.6568 61.1192 22.944 60.7064 23.3102 60.3546C23.6835 60.0028 24.1179 59.7336 24.6132 59.5469C25.1086 59.3531 25.6507 59.2561 26.2394 59.2561C26.8927 59.2561 27.4814 59.371 28.0055 59.6008C28.5368 59.8233 28.982 60.1536 29.3409 60.5915L28.2209 61.6254C27.9625 61.331 27.6753 61.112 27.3594 60.9684C27.0435 60.8177 26.6989 60.7423 26.3255 60.7423C25.9738 60.7423 25.6507 60.7997 25.3563 60.9146C25.062 61.0295 24.8071 61.1946 24.5917 61.41C24.3763 61.6254 24.2076 61.8802 24.0855 62.1746C23.9707 62.469 23.9132 62.7956 23.9132 63.1546C23.9132 63.5136 23.9707 63.8402 24.0855 64.1346C24.2076 64.429 24.3763 64.6838 24.5917 64.8992C24.8071 65.1146 25.062 65.2797 25.3563 65.3946C25.6507 65.5095 25.9738 65.5669 26.3255 65.5669C26.6989 65.5669 27.0435 65.4951 27.3594 65.3515C27.6753 65.2008 27.9625 64.9746 28.2209 64.6731L29.3409 65.7069C28.982 66.1449 28.5368 66.4787 28.0055 66.7084C27.4814 66.9382 26.8891 67.0531 26.2286 67.0531ZM34.0013 67.0531C33.4054 67.0531 32.8562 66.9597 32.3536 66.7731C31.8582 66.5792 31.4239 66.3064 31.0505 65.9546C30.6844 65.6028 30.3972 65.19 30.189 64.7161C29.988 64.2423 29.8875 63.7218 29.8875 63.1546C29.8875 62.5874 29.988 62.0669 30.189 61.5931C30.3972 61.1192 30.688 60.7064 31.0613 60.3546C31.4347 60.0028 31.8726 59.7336 32.3752 59.5469C32.8777 59.3531 33.4305 59.2561 34.0336 59.2561C34.7013 59.2561 35.3008 59.3674 35.8321 59.59C36.3705 59.8125 36.8229 60.1356 37.189 60.5592L36.069 61.5931C35.7962 61.3059 35.4982 61.0941 35.1752 60.9577C34.8521 60.8141 34.5003 60.7423 34.1198 60.7423C33.7536 60.7423 33.4198 60.7997 33.1182 60.9146C32.8167 61.0295 32.5547 61.1946 32.3321 61.41C32.1167 61.6254 31.948 61.8802 31.8259 62.1746C31.7111 62.469 31.6536 62.7956 31.6536 63.1546C31.6536 63.5064 31.7111 63.8295 31.8259 64.1238C31.948 64.4182 32.1167 64.6766 32.3321 64.8992C32.5547 65.1146 32.8131 65.2797 33.1075 65.3946C33.409 65.5095 33.7393 65.5669 34.0982 65.5669C34.4429 65.5669 34.7767 65.5131 35.0998 65.4054C35.43 65.2905 35.7495 65.1002 36.0582 64.8346L37.049 66.0946C36.6398 66.4033 36.1623 66.6402 35.6167 66.8054C35.0782 66.9705 34.5398 67.0531 34.0013 67.0531ZM35.4552 65.8684V63.0361H37.049V66.0946L35.4552 65.8684Z'
      fill='#ffffff'
    />
    <defs>
      <linearGradient
        id='paint0_linear_515_30'
        x1='25.1877'
        y1='9.38448'
        x2='64.1237'
        y2='58.6871'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_515_30'
        x1='11.0774'
        y1='27.3851'
        x2='40.0005'
        y2='55.5389'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCBA73' />
        <stop offset='1' stopColor='#C86904' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_515_30'
        x1='50.0005'
        y1='42.1541'
        x2='57.6928'
        y2='50.7695'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCBA73' />
        <stop offset='1' stopColor='#C86904' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_515_30'
        x1='8.9463'
        y1='57.3184'
        x2='22.6083'
        y2='70.9804'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#414CC8' />
        <stop offset='1' stopColor='#2B3493' />
      </linearGradient>
    </defs>
  </svg>,
  'ACCG',
);
